import { useState, useEffect } from 'react';
import { Flex } from '@chakra-ui/react';
import Selectable from 'components/common/Selectable/Selectable';
import { useFetchBuckets } from 'hooks';
import { Modal, ModalBody, Button, ModalHeader, Spinner } from 'components/UI';

const BucketSelect = ({
  onChange,
  onCancel,
  policy,
}: {
  onChange(): void;
  onCancel(): void;
  policy: string | undefined;
}) => {
  const [buckets, setBuckets] = useState<string[]>([]);
  const [fetchBuckets] = useFetchBuckets();
  const [loading, setLoading] = useState(false);
  const handleLoadBuckets = async () => {
    setLoading(true);
    const res = (await fetchBuckets()) as [
      {
        bucketKey: string;
        createdDate: number;
        policyKey: string;
      }
    ];
    const newBuckets = policy ? res.filter((bucket: { policyKey: string }) => bucket.policyKey === policy) : res;
    const bucketNames = newBuckets.map((bucket: { bucketKey: string }) => bucket.bucketKey);
    setBuckets(bucketNames);
    setLoading(false);
  };

  useEffect(() => {
    handleLoadBuckets();
  }, []);
  const renderSelectable = loading ? <Spinner /> : <Selectable options={buckets} onChange={onChange} />;
  return (
    <Modal isOpen isCloseButton closeOnEsc={false} closeOnOverlayClick isCentered size="xs" onClose={onCancel}>
      <ModalHeader textAlign="center" fontSize="xl" pb={0}>
        Select a Bucket
      </ModalHeader>
      <ModalBody>
        <Flex
          sx={{
            mb: 2.5,
            justifyContent: 'center',
            w: '100%',
          }}
        >
          {renderSelectable}
        </Flex>
        <Flex
          sx={{
            mb: 2.5,
            justifyContent: 'center',
          }}
        >
          <Button onClick={onCancel} size="sm">
            CANCEL
          </Button>
        </Flex>
      </ModalBody>
    </Modal>
  );
};

export default BucketSelect;
